<template>
  <link
    rel="stylesheet"
    href="https://fonts.googleapis.com/icon?family=Material+Icons"
  />
  <link
    rel="stylesheet"
    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
  />
  <img src="../assets/images/principal/allikamay_2.png" class="d-block mx-auto"/>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card shadow">
          <div class="card-header bg-primary text-white d-flex align-items-center">
            <span class="material-symbols-outlined me-2">corporate_fare</span>
            <h4 class="mb-0">Seleccione una Empresa</h4>
          </div>
          <div class="card-body">
            <p class="text-muted">Por favor, seleccione la empresa con la que desea trabajar en esta sesión:</p>
            
            <div class="list-group">
              <button 
                v-for="empresa in empresas" 
                :key="empresa.idEmpresa"
                type="button" 
                class="list-group-item list-group-item-action d-flex justify-content-between align-items-center p-3"
                @click="seleccionarEmpresa(empresa)"
              >
                <div>
                  <div class="fw-bold text-uppercase">{{ empresa.nombreCorto }}</div>
                  <small class="text-secondary">{{ empresa.razonSocial }}</small>
                  <div class="text-muted small">
                    <span class="material-icons" style="font-size: 12px;">location_on</span>
                    {{ empresa.localidadNombre }} - {{ empresa.ciudad }}
                  </div>
                </div>
                <span class="material-symbols-outlined text-primary">arrow_forward_ios</span>
              </button>
            </div>

            <div v-if="empresas.length === 0" class="text-center p-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Cargando...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import Swal from "sweetalert2";

export default {
  name: "SeleccionEmpresa",
  data() {
    return {
      empresas: []
    };
  },
  mounted() {
    this.fetchEmpresas();
  },
  methods: {
    async fetchEmpresas() {
      try {
        const response = await api.get("/vwempresas");
        this.empresas = response.data;
      } catch (error) {
        console.error("Error al cargar empresas:", error);
        Swal.fire({
          icon: "error",
          title: "Error de conexión",
          text: "No se pudieron cargar las empresas del sistema."
        });
      }
    },
seleccionarEmpresa(empresa) {
  sessionStorage.setItem("idEmpresa",    empresa.idEmpresa);
  sessionStorage.setItem("empresaNombre", empresa.nombreCorto);
  sessionStorage.setItem("empresaData",  JSON.stringify(empresa));

  Swal.fire({
    icon: "success",
    title: "Empresa Seleccionada",
    text: `Ahora trabajando con: ${empresa.nombreCorto}`,
    timer: 500,
    showConfirmButton: false
  }).then(() => {
    this.$router.push("/MenuPrincipal");
  });
}
  }
};
</script>

<style scoped>
.list-group-item:hover {
  background-color: #f8f9fa;
  border-left: 4px solid #0d6efd;
}
</style>